<div class="inner">
  <ng-content></ng-content>
</div>
